
















































































































































































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import {
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'
import Loader from '@/components/misc/Loader.vue'
import { toDCM, trimmedLocaleString } from '@/helper'
import { TransactionResponse } from '@/store/modules/transactions/models'
import CopyText from '@/components/misc/CopyText.vue'
@Component({
    components: { Tooltip, Loader, CopyText },
    filters: {
        toDCM,
        trimmedLocaleString,
    },
})
export default class RecentInternalTransactions extends Vue {
    chainDenomination = 9

    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get currentActChainID() {
        return DEFAULT_NETWORK.actChainId
    }

    shortenText(source: string, index: number) {
        if (index >= source.length) return source

        return `${source.substring(0, index)}...${source.substring(
            source.length - index,
            source.length
        )}`
    }

    isACTAddress(address: string) {
        return address.startsWith('0x')
    }

    generateURL(path: string) {
        const baseURL = path
        const queryParams: { [key: string]: string } = {
            network: DEFAULT_NETWORK_NAME,
        }

        const url = new URL(baseURL, window.location.origin)
        Object.keys(queryParams).forEach((key) => {
            url.searchParams.append(key, queryParams[key])
        })

        return url.toString()
    }
    getExternalLink(address: string) {
        return this.generateURL(`/evmaddress/${address}`)
    }

    getInternalLink(address: string) {
        return this.generateURL(`/address/${address}`)
    }

    getFromAddress(tx: TransactionResponse) {
        const input = tx.inputs.at(0)
        if (input?.credentials) {
            const creds = input.credentials as any
            return creds.at(0).address
        } else if (input?.output) return input.output.caddresses.at(0)
        else return ''
    }
    getToAddress(tx: TransactionResponse): any {
        const output = tx.outputs.at(0)
        if (output?.addresses) return output.addresses.at(0)
        else if (output?.caddresses) return output.caddresses.at(0)
        return ''
    }

    amount(tx: TransactionResponse) {
        const output = tx.outputs.at(0)

        const value = output?.amount || '0'

        return toDCM(value)
    }

    convertToCurrency(amount: any) {
        // return Math.abs(Number(amount)) >= 1.0e9
        //     ? (Math.abs(Number(amount)) / 1.0e9).toFixed(5) + 'B'
        //     : // Six Zeroes for Millions
        //     Math.abs(Number(amount)) >= 1.0e6
        //     ? (Math.abs(Number(amount)) / 1.0e6).toFixed(5) + 'M'
        //     : // Three Zeroes for Thousands
        //     Math.abs(Number(amount)) >= 1.0e3
        //     ? (Math.abs(Number(amount)) / 1.0e3).toFixed(5) + 'K'
        //     : Math.abs(Number(amount))

        return trimmedLocaleString(amount)
    }

    get transactions(): TransactionResponse[] {
        return this.$store.state.Transactions.recentTxRes.transactions
    }
}
